import { render, staticRenderFns } from "./PersonalPropertyInvoice.vue?vue&type=template&id=310a8ce2"
import script from "./PersonalPropertyInvoice.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports